import { render, staticRenderFns } from "./WyfHero.vue?vue&type=template&id=1998e75c"
var script = {}
import style0 from "./WyfHero.vue?vue&type=style&index=0&id=1998e75c&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports